import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useTDspjdListQuery } from '../../../store/DianShangYeWuApi'
import RuleReportAdd from './RuleReportAdd'
import RuleReportEdit from './RuleReportEdit'
import RuleReportCopy from './RuleReportCopy'
function RuleReportList(props) {
    
    const [list, setList] = useState([])
    const {data, isSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
        }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'dsbzd_spjd_id',
            key: 'dsbzd_spjd_id',
            render: (text, record) => <RuleReportCopy 
                                        dsbzd_spjd_id={record.dsbzd_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '团队报账单规则名称',
            dataIndex: 'dsbzd_spjd_content',
            key: 'dsbzd_spjd_content',
            render: (text, record) => <RuleReportEdit 
                                        dsbzd_spjd_content={text} 
                                        dsbzd_spjd_id={record.dsbzd_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '团队报账单部门',
            dataIndex: 'dsbzd_spjd_bm_name',
            key: 'dsbzd_spjd_bm_name',
        },
        // {
        //     title: '团队报账单操作员',
        //     dataIndex: 'dsbzd_spjd_user_name',
        //     key: 'dsbzd_spjd_user_name',
        // },
        {
            title: '新增记录',
            dataIndex: 'dsbzd_spjd_uname',
            key: 'dsbzd_spjd_uname',
            render: (text, record) => <span>{record.dsbzd_spjd_uname} {record.dsbzd_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
               <RuleReportAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='dsbzd_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleReportList